import styled, { css } from 'styled-components';

export const Pipe = styled.div<{ color: string }>`
  height: 2px;
  width: 100%;
  background-color: ${({ color }) => color};
`;

export const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
`;
export const IconWrapper = styled.div`
  margin: 9px;
`;

export const StepContainer = styled.div<{ lastChild: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${({ lastChild }) =>
    !lastChild &&
    css`
      flex: 1;
    `}
`;
export const StepperContainer = styled.div`
  display: flex;
`;

export const TitleContarner = styled.div`
  color: ${({ theme }) => theme.gray4D};
  font-size: 16px;
  font-weight: 700;
  text-align: center;
`;

export const SubtileTitleContarner = styled.div`
  color: ${({ theme }) => theme.gray4D};
  font-size: 14px;
  font-weight: 400;
  width: 140px;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: center;
`;

export const TitlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 38px;
  align-items: center;
`;

export const StatusStepperWrapper = styled.div`
  width: 100%;
`;
export const ContentSection = styled.div`
  width: 100%;
`;
export const ContentWrapper = styled.div``;
export const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  top: 66px;
`;
